import SingleImageCarousel from './components/SingleImageCarousel/SingleImageCarousel';

export default SingleImageCarousel;
